import { REFUND_STATUS_LABEL, REFUND_STATUS_TONE } from '../../Enums/money-out.enum';
import { RefundResponse } from '../../Interfaces/api/backoffice/billing-document.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class Refund {
  id = '';
  payment_id = '';
  stripe_refund_id: string | null = null;
  amount = 0;
  currency: string | null = null;
  reason: string | null = null;
  status: string | null = null;
  created_by: string | null = null;
  created_at: string | null = null;

  constructor(data: Partial<RefundResponse> = {}) {
    Object.assign(this, data);
  }

  get statusLabelKey(): string {
    return this.status ? (REFUND_STATUS_LABEL[this.status] ?? this.status) : '';
  }

  get statusTone(): StatusTone {
    return this.status ? (REFUND_STATUS_TONE[this.status] ?? 'neutral') : 'neutral';
  }
}
